import DoAPICall from './DoAPICall'

//Payments CRUD
   export async function getPayment(userToken, id){
      const apiPayload = {
         httpMethod:'get',
         userToken,
         uri:'payments/'+id,
         payLoad:{},
         requestOptions:{}
      }
      return await DoAPICall(apiPayload)
   }

   export async function updatePayment(userToken, payment){
      const apiPayload = {
         httpMethod:'put',
         userToken,
         uri:'payments/'+payment.id,

         payLoad:{
            menu_id:payment.menu_id,
            ppTransactionId:payment.ppTransactionId,
            transactionId:payment.transactionId,
            reference:payment.reference,
            paymentAmount:payment.paymentAmount,
            receiptNumber:payment.receiptNumber,
            tokenNumber:payment.tokenNumber,
            receipt:payment.receipt,
            channel:payment.channel,
            paymentStatus:payment.paymentStatus,
            error:""
         },
         requestOptions:{}
      }
      return await DoAPICall(apiPayload)
   }

//

//Payment Reports routes
   export async function getPaymentTransactions(userToken, params){
      const apiPayload = {
         httpMethod:'get',
         userToken,
         uri:'paymenttransactions?dateFrom='+params.from+'&dateTo='+params.to,
         payLoad:{},
         requestOptions:{}
      }
      return await DoAPICall(apiPayload)
   }

   export async function getPaymentsNotReceipted(userToken, params){
      const apiPayload = {
         httpMethod:'get',
         userToken,
         uri:'paymentsnotreceipted?dateFrom='+params.from+'&dateTo='+params.to,
         payLoad:{},
         requestOptions:{}
      }
      return await DoAPICall(apiPayload)
   }

   export async function getSubmittedPayments(userToken, theMonth){
      const apiPayload = {
         httpMethod:'get',
         userToken,
         uri:'submittedpayments?theMonth='+theMonth,
         payLoad:{},
         requestOptions:{}
      }
      return await DoAPICall(apiPayload)
   }

   export async function getFailedPayments(userToken, params){
      const apiPayload = {
         httpMethod:'get',
         userToken,
         uri:'failedpayments?dateFrom='+params.from+'&dateTo='+params.to,
         payLoad:{},
         requestOptions:{}
      }
      return await DoAPICall(apiPayload)
   }

//Update Payments
   export async function receiptPayment(userToken,urlPrefix, id){
         const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'clientreceipts',
            payLoad:{
               id,
               urlPrefix
            },
            requestOptions:{}
         }
         return await DoAPICall(apiPayload)
      }

   export async function issueToken(userToken,urlPrefix, id){
         const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'tokens',
            payLoad:{
               id,
               urlPrefix
            },
            requestOptions:{}
         }
         return await DoAPICall(apiPayload)
      }

   export async function deliverReceipt(userToken,urlPrefix, id){
         const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'paymentreceipts/'+id,
            payLoad:{
               urlPrefix
            },
            requestOptions:{}
         }
         return await DoAPICall(apiPayload)
      }

   export async function batchReceiptDelivery(userToken, params){
         const apiPayload = {
            httpMethod:'post',
            userToken,
            uri:'batchpaymentreceipts',
            payLoad:{
               dateFrom:params.from,
               dateTo:params.to,
            },
            requestOptions:{}
         }
         return await DoAPICall(apiPayload)
      }
  
   export async function reviewPayment(userToken, id){
         const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'failedpayments/'+id,
            payLoad:{},
            requestOptions:{}
         }
         return await DoAPICall(apiPayload)
      }

   export async function reviewSubmittedPayment(userToken, id){
         const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'submittedpayments/'+id,
            payLoad:{},
            requestOptions:{}
         }
         return await DoAPICall(apiPayload)
      }

   export async function batchpaymentreview(userToken, params){
         const apiPayload = {
             httpMethod:'post',
             userToken,
             uri:'paymentsreviewbatch',
             payLoad:{
                 dateFrom:params.from,
                 dateTo:params.to,
             },
             requestOptions:{}
         }
         return await DoAPICall(apiPayload)
     }